<div>
  <table class="table rl-table table-hover" cdkDropList (cdkDropListDropped)="drop($event)">
    <thead>
      <tr>
        <th class="ps-4"></th>
        <th class="text-nowrap">Rule Set</th>
        <th class="text-nowrap">Account</th>
        <th class="text-nowrap">Rule Source</th>
        <th class="text-nowrap">Rule Type</th>
        <th class="text-nowrap">Picklist Field</th>
        <th class="text-nowrap">Trigger Value(s)</th>
        <th></th>
      </tr>
    </thead>
    <!-- guarded rather than relying on .no-items-message:not(:last-child): the Set rows live in
      sibling tbodys (see below), so the row is always its own tbody's last child and the CSS
      that normally hides it can never fire -->
    @if (!ruleSets?.length) {
      <tbody>
        <tr class="no-items-message">
          <td colspan="8" class="border-0">
            <div class="d-flex align-items-center justify-content-center pt-3">
              <i class="fal fa-table-list"></i>
              <h5 class="mb-0 ms-3">No Rule Sets found.</h5>
            </div>
          </td>
        </tr>
      </tbody>
    }
    <!-- one tbody per Set so the drag handle moves the Set together with its rules: a tr cannot
      wrap sibling trs, so the tbody is the only valid drag unit here -->
    @for (ruleSet of ruleSets; track ruleSet.groupRuleSetId) {
      <tbody cdkDrag cdkDragLockAxis="y">
        <tr class="rule-set-row">
          <td class="ps-1 text-nowrap">
            <span class="pt-1 drag__handle position-relative" cdkDragHandle>
              <i class="far fa-ellipsis-vertical"></i>
            </span>
            <i class="fal fa-chevron-right cursor-pointer toggle-chevron p-1"
              [class.open]="!isCollapsed(ruleSet.groupRuleSetId)"
              [title]="isCollapsed(ruleSet.groupRuleSetId) ? 'Expand' : 'Collapse'"
              [attr.data-cy]="isCollapsed(ruleSet.groupRuleSetId) ? 'ToExpandRuleSet' : 'ToCollapseRuleSet'"
              (click)="toggle(ruleSet.groupRuleSetId)">
            </i>
          </td>
          <td>{{ ruleSet.name }}</td>
          <td>{{ getAccountName(ruleSet.accountId) }}</td>
          <td colspan="4"></td>
          <td class="p-1">
            <div class="hover-icons text-end">
              <button class="btn btn-icon btn-success btn-sm me-2" title="Add Rule"
                data-cy="AddRuleToRuleSet"
                (click)="addOrEditAccountGroupRule(ruleSet)">
                <i class="far fa-plus fa-sm"></i>
              </button>
              <button class="btn btn-icon btn-info btn-sm me-2" title="Edit Rule Set"
                data-cy="EditRuleSet"
                (click)="editRuleSet.emit({ group: accountGroup, ruleSet })">
                <i class="fal fa-pencil fa-sm"></i>
              </button>
              <button class="btn btn-icon btn-remove btn-sm me-1" title="Delete Rule Set"
                data-cy="DeleteRuleSet"
                (click)="deleteRuleSet(ruleSet, deleteRuleSetPrompt)">
                <i class="fal fa-trash-can fa-sm"></i>
              </button>
            </div>
          </td>
        </tr>
        @if (!isCollapsed(ruleSet.groupRuleSetId)) {
          <rl-account-group-rules [accountGroup]="accountGroup" [ruleSet]="ruleSet"
            [hlcCache]="hlcCache"
            (edit)="addOrEditAccountGroupRule(ruleSet, $event)"></rl-account-group-rules>
        }
      </tbody>
    }
  </table>
</div>

<ng-template #deleteRuleSetPrompt let-prompt="prompt">
  <div>
    <p>
      Are you sure you want to delete this Rule Set and all of its rules?
    </p>
  </div>
  <div class="text-end mt-3 w-100">
    <button class="btn btn-light btn-sm" (click)="prompt.onConfirm.next(false)" data-cy="cancelDeleteRuleSet">
      Cancel
    </button>
    <button class="btn btn-success btn-sm ms-2" (click)="prompt.onConfirm.next(true)"
      data-cy="confirmDeleteRuleSet">
      Delete Rule Set
    </button>
  </div>
</ng-template>
